"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboChartStackingConfig = exports.canComboChartBeStackedInPercent = exports.getComboChartSeries = exports.COMBO_SUPPORTED_CHARTS = exports.CHART_ORDER = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var common_1 = require("../_util/common");
exports.CHART_ORDER = (_a = {},
    _a[sdk_ui_1.VisualizationTypes.AREA] = 1,
    _a[sdk_ui_1.VisualizationTypes.COLUMN] = 2,
    _a[sdk_ui_1.VisualizationTypes.LINE] = 3,
    _a);
/**
 * @internal
 */
exports.COMBO_SUPPORTED_CHARTS = [
    sdk_ui_1.VisualizationTypes.COLUMN,
    sdk_ui_1.VisualizationTypes.LINE,
    sdk_ui_1.VisualizationTypes.AREA,
];
var DEFAULT_COMBO_CHART_TYPES = [sdk_ui_1.VisualizationTypes.COLUMN, sdk_ui_1.VisualizationTypes.LINE];
function getMeasureIndices(bucketItems, measureGroupIdentifiers) {
    return bucketItems.reduce(function (result, item) {
        var localIdentifier = sdk_model_1.isMeasure(item) ? sdk_model_1.measureLocalId(item) : "";
        if (localIdentifier) {
            var metricIndex = measureGroupIdentifiers.indexOf(localIdentifier);
            result.push(metricIndex);
        }
        return result;
    }, []);
}
function getComboChartSeries(config, measureGroup, series, dv) {
    var updatedSeries = cloneDeep_1.default(series);
    var measureBuckets = {};
    var types = [config.primaryChartType, config.secondaryChartType];
    var measureGroupIdentifiers = measureGroup.items.map(function (item) { var _a, _b; return (_b = (_a = item === null || item === void 0 ? void 0 : item.measureHeaderItem) === null || _a === void 0 ? void 0 : _a.localIdentifier) !== null && _b !== void 0 ? _b : ""; });
    dv.def()
        .buckets()
        .forEach(function (bucket) {
        var bucketItems = bucket.items || [];
        measureBuckets[bucket.localIdentifier] = getMeasureIndices(bucketItems, measureGroupIdentifiers);
    });
    [sdk_ui_1.BucketNames.MEASURES, sdk_ui_1.BucketNames.SECONDARY_MEASURES].forEach(function (name, index) {
        (measureBuckets[name] || []).forEach(function (measureIndex) {
            var chartType = exports.CHART_ORDER[types[index]]
                ? types[index]
                : DEFAULT_COMBO_CHART_TYPES[index];
            set_1.default(updatedSeries, [measureIndex, "type"], chartType);
            set_1.default(updatedSeries, [measureIndex, "zIndex"], exports.CHART_ORDER[chartType]);
        });
    });
    return updatedSeries;
}
exports.getComboChartSeries = getComboChartSeries;
function isAllSeriesOnLeftAxis(series) {
    if (series === void 0) { series = []; }
    return series.every(function (item) { return item.yAxis === 0; });
}
function isSomeSeriesWithLineChart(series) {
    if (series === void 0) { series = []; }
    return series.some(function (item) { return common_1.isLineChart(item.type); });
}
function canComboChartBeStackedInPercent(series) {
    var isAllSeriesOnLeft = isAllSeriesOnLeftAxis(series);
    var hasLineChartType = isSomeSeriesWithLineChart(series);
    return !(isAllSeriesOnLeft && hasLineChartType);
}
exports.canComboChartBeStackedInPercent = canComboChartBeStackedInPercent;
function getComboChartStackingConfig(config, series, defaultStacking) {
    var stackMeasures = config.stackMeasures;
    var canStackInPercent = canComboChartBeStackedInPercent(series);
    if (canStackInPercent) {
        return defaultStacking;
    }
    return stackMeasures ? "normal" : null;
}
exports.getComboChartStackingConfig = getComboChartStackingConfig;
//# sourceMappingURL=comboChartOptions.js.map